/* =====================================================================
   PeakForm Theme JS — Dawn 15.4.1
   Handles: FAQ accordion, sticky ATC, cart drawer (Shopify AJAX API),
            variant picker, qty controls, buy-now direct checkout,
            volume tier picker, live cart status, Judge.me auto-swap,
            video sound toggle
===================================================================== */
(function () {
  'use strict';

  // ─────────────── FAQ accordion ───────────────
  document.addEventListener('click', function (e) {
    const q = e.target.closest('.pf-faq__q');
    if (!q) return;
    q.parentElement.classList.toggle('is-open');
  });

  // ─────────────── Quantity stepper ───────────────
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('[data-pf-qty]');
    if (!btn) return;
    const wrap = btn.closest('.pf-pdp__qty');
    const input = wrap.querySelector('input');
    const dir = btn.dataset.pfQty === 'up' ? 1 : -1;
    const next = Math.max(1, parseInt(input.value || '1', 10) + dir);
    input.value = next;
    input.dispatchEvent(new Event('input', { bubbles: true }));
  });

  // Money formatter — uses shop currency
  window.pfFormatMoney = function (cents) {
    const amt = (cents / 100);
    const currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'sl-SI', {
        style: 'currency', currency: currency, minimumFractionDigits: 2
      }).format(amt);
    } catch (e) {
      return amt.toFixed(2) + ' €';
    }
  };

  // ─────────────── Variant picker (PDP) ───────────────
  const pdp = document.querySelector('[data-pf-pdp]');
  if (pdp) {

    // ─── Judge.me auto-swap (uses real reviews if available) ───
    function tryJudgemeSwap() {
      const ratingWrap = pdp.querySelector('[data-pf-rating]');
      const judgemeBadge = pdp.querySelector('[data-pf-judgeme-source] .jdgm-prev-badge');
      if (!ratingWrap || !judgemeBadge) return false;
      const score = parseFloat(judgemeBadge.dataset.averageRating || '0');
      const count = parseInt(judgemeBadge.dataset.numberOfReviews || '0', 10);
      if (score > 0 && count > 0) {
        const scoreEl = ratingWrap.querySelector('[data-pf-rating-score]');
        const countEl = ratingWrap.querySelector('[data-pf-rating-count]');
        const starsEl = ratingWrap.querySelector('[data-pf-rating-stars]');
        if (scoreEl) scoreEl.textContent = score.toFixed(1) + '/5';
        if (countEl) countEl.textContent = count + ' ocen';
        if (starsEl) {
          starsEl.innerHTML = '';
          const full = Math.floor(score);
          const hasHalf = score - full >= 0.25 && score - full < 0.75;
          for (let i = 1; i <= 5; i++) {
            const span = document.createElement('span');
            span.className = 'pf-pdp__star';
            if (i <= full) span.classList.add('pf-pdp__star--full');
            else if (i === full + 1 && hasHalf) span.classList.add('pf-pdp__star--half');
            span.textContent = '★';
            starsEl.appendChild(span);
          }
        }
        return true;
      }
      return false;
    }
    let jmTries = 0;
    const jmInterval = setInterval(() => {
      if (tryJudgemeSwap() || ++jmTries > 10) clearInterval(jmInterval);
    }, 800);

    const form = pdp.querySelector('form[data-pf-atc-form]');
    const variantInput = form && form.querySelector('input[name="id"]');
    const priceEl = pdp.querySelector('[data-pf-price-cur]');
    const oldEl = pdp.querySelector('[data-pf-price-old]');
    const saveEl = pdp.querySelector('[data-pf-price-save]');
    const variants = (window.pfVariants || []);
    const state = { options: [] };

    const first = variants.find(v => v.available) || variants[0];
    if (first) state.options = (first.options || []).slice();

    function updateVariant() {
      const match = variants.find(v =>
        (v.options || []).every((o, i) => o === state.options[i])
      );
      if (!match) return;
      if (variantInput) variantInput.value = match.id;
      if (priceEl) priceEl.textContent = window.pfFormatMoney(match.price);
      if (oldEl) {
        if (match.compare_at_price && match.compare_at_price > match.price) {
          oldEl.textContent = window.pfFormatMoney(match.compare_at_price);
          oldEl.style.display = '';
          if (saveEl) {
            const pct = Math.round(((match.compare_at_price - match.price) / match.compare_at_price) * 100);
            saveEl.textContent = 'Prihraniš ' + pct + '%';
            saveEl.style.display = '';
          }
        } else {
          oldEl.style.display = 'none';
          if (saveEl) saveEl.style.display = 'none';
        }
      }
      const atc = form.querySelector('[data-pf-atc]');
      if (atc) {
        atc.disabled = !match.available;
        atc.textContent = match.available ? atc.dataset.labelAvail || 'Dodaj v košarico' : (atc.dataset.labelOos || 'Razprodano');
      }
      if (typeof renderTiers === 'function') renderTiers();
    }

    pdp.querySelectorAll('[data-pf-opt]').forEach(btn => {
      btn.addEventListener('click', () => {
        const idx = parseInt(btn.dataset.pfOptIdx, 10);
        const val = btn.dataset.pfOpt;
        state.options[idx] = val;
        pdp.querySelectorAll(`[data-pf-opt-idx="${idx}"]`).forEach(b => b.classList.remove('is-active'));
        btn.classList.add('is-active');
        updateVariant();
      });
    });

    // ─── Volume tier picker ───
    const tierWrap = pdp.querySelector('[data-pf-tiers]');
    const qtyInput = form && form.querySelector('input[name="quantity"]');
    var renderTiers = function () {};
    if (tierWrap && qtyInput) {
      const d2 = parseFloat(tierWrap.dataset.d2) || 0;
      const d3 = parseFloat(tierWrap.dataset.d3) || 0;

      function getCurrentBase() {
        const match = variants.find(v => (v.options || []).every((o, i) => o === state.options[i]));
        return match ? match.price : parseInt(tierWrap.dataset.basePrice, 10) || 0;
      }

      renderTiers = function () {
        const base = getCurrentBase();
        const tiers = [
          { qty: 1, pct: 0 },
          { qty: 2, pct: d2 },
          { qty: 3, pct: d3 }
        ];
        tiers.forEach(t => {
          const original = base * t.qty;
          const finalP = Math.round(original * (1 - t.pct / 100));
          const save = original - finalP;
          const pEl = tierWrap.querySelector(`[data-pf-tier-price="${t.qty}"]`);
          const oEl = tierWrap.querySelector(`[data-pf-tier-old="${t.qty}"]`);
          const sEl = tierWrap.querySelector(`[data-pf-tier-save="${t.qty}"]`);
          if (pEl) pEl.textContent = window.pfFormatMoney(finalP);
          if (oEl) oEl.textContent = t.pct > 0 ? window.pfFormatMoney(original) : '';
          if (sEl) sEl.textContent = t.pct > 0 ? 'prihraniš ' + window.pfFormatMoney(save) : '';
        });
      };

      function highlightTier(qty) {
        tierWrap.querySelectorAll('[data-pf-tier]').forEach(b => {
          const isMatch = parseInt(b.dataset.pfTier, 10) === qty;
          b.classList.toggle('is-active', isMatch);
        });
      }

      tierWrap.querySelectorAll('[data-pf-tier]').forEach(btn => {
        btn.addEventListener('click', () => {
          const q = parseInt(btn.dataset.pfTier, 10);
          qtyInput.value = q;
          highlightTier(q);
        });
      });

      qtyInput.addEventListener('input', () => {
        const q = parseInt(qtyInput.value, 10) || 1;
        highlightTier(q >= 1 && q <= 3 ? q : 0);
      });

      renderTiers();
      highlightTier(2);
    }

    updateVariant();

    // ─── Live cart status indicator ───
    const cartStatusEl = pdp.querySelector('[data-pf-cart-status]');
    if (cartStatusEl) {
      const productIdStr = String(window.pfProductId || cartStatusEl.dataset.productId || '');
      function updateCartStatus(cart) {
        if (!cart || !Array.isArray(cart.items)) return;
        const total = cart.items.reduce((sum, item) => {
          return String(item.product_id) === productIdStr ? sum + item.quantity : sum;
        }, 0);
        if (total > 0) {
          cartStatusEl.textContent = 'v košarici: ' + total + 'x';
          cartStatusEl.classList.add('has-items');
        } else {
          cartStatusEl.textContent = 'v košarici: prazna';
          cartStatusEl.classList.remove('has-items');
        }
      }
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(r => r.json()).then(updateCartStatus).catch(() => {});
      document.addEventListener('pf:cart-updated', e => updateCartStatus(e.detail));
    }

    // Gallery thumbs
    const mainImg = pdp.querySelector('[data-pf-main-img] img');
    pdp.querySelectorAll('[data-pf-thumb]').forEach(t => {
      t.addEventListener('click', () => {
        pdp.querySelectorAll('[data-pf-thumb]').forEach(x => x.classList.remove('is-active'));
        t.classList.add('is-active');
        if (mainImg) mainImg.src = t.dataset.pfThumb;
      });
    });
  }

  // ─────────────── Cart drawer (Shopify AJAX API) ───────────────
  const drawer = document.querySelector('[data-pf-cart-drawer]');
  const scrim = document.querySelector('[data-pf-cart-scrim]');
  const flash = document.querySelector('[data-pf-cart-flash]');
  const itemsWrap = drawer && drawer.querySelector('[data-pf-cart-items]');
  const totalEl = drawer && drawer.querySelector('[data-pf-cart-total]');
  const shipEl = drawer && drawer.querySelector('[data-pf-cart-ship]');
  const shipBar = drawer && drawer.querySelector('[data-pf-cart-ship-bar]');
  const countEls = document.querySelectorAll('[data-pf-cart-count]');
  const FREE_SHIP_THRESHOLD = parseInt((drawer && drawer.dataset.freeShip) || '5000', 10);

  function openDrawer() {
    if (!drawer) {
      console.warn('[PF] pf-cart-drawer element not found on page');
      return;
    }
    drawer.classList.add('is-open');
    scrim && scrim.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer() {
    drawer && drawer.classList.remove('is-open');
    scrim && scrim.classList.remove('is-open');
    document.body.style.overflow = '';
  }
  scrim && scrim.addEventListener('click', closeDrawer);

  document.addEventListener('click', function (e) {
    const open = e.target.closest('[data-pf-cart-open]');
    if (open && !open.closest('[data-pf-sticky-atc]')) {
      e.preventDefault();
      openDrawer();
      fetchCart();
      return;
    }
    const close = e.target.closest('[data-pf-cart-close]');
    if (close) { e.preventDefault(); closeDrawer(); return; }
  });

  function showFlash(msg) {
    if (!flash) return;
    flash.textContent = msg || '✓ Izdelek dodan';
    flash.classList.add('is-visible');
    clearTimeout(flash._t);
    flash._t = setTimeout(() => flash.classList.remove('is-visible'), 2200);
  }

  function renderCart(cart) {
    if (!itemsWrap) return;
    countEls.forEach(el => { el.textContent = cart.item_count; el.style.display = cart.item_count > 0 ? '' : 'none'; });

    if (cart.item_count === 0) {
      itemsWrap.innerHTML = '<div class="pf-cart-empty">Tvoja košarica je prazna.<br><br>Začni z nakupovanjem in odkrij naše izdelke.</div>';
    } else {
      itemsWrap.innerHTML = cart.items.map(item => {
        const hasDiscount = item.original_line_price > item.final_line_price;
        const lineSave = item.original_line_price - item.final_line_price;
        return `
        <div class="pf-cart-item" data-pf-line="${item.key}">
          <div class="pf-cart-item__img"><img src="${item.image || ''}" alt=""></div>
          <div class="pf-cart-item__body">
            <div class="pf-cart-item__name">${item.product_title}</div>
            ${item.variant_title && item.variant_title !== 'Default Title' ? `<div class="pf-cart-item__variant">${item.variant_title}</div>` : ''}
            <div class="pf-cart-item__qty">
              <button data-pf-line-qty="down" aria-label="Zmanjšaj">−</button>
              <span>${item.quantity}</span>
              <button data-pf-line-qty="up" aria-label="Povečaj">+</button>
            </div>
            ${hasDiscount ? `<div class="pf-cart-item__line-save">prihraniš ${window.pfFormatMoney(lineSave)}</div>` : ''}
          </div>
          <div class="pf-cart-item__right">
            <div class="pf-cart-item__price">
              ${hasDiscount ? `<span class="pf-cart-item__price-old">${window.pfFormatMoney(item.original_line_price)}</span>` : ''}
              <span class="pf-cart-item__price-cur">${window.pfFormatMoney(item.final_line_price)}</span>
            </div>
            <button class="pf-cart-item__remove" data-pf-line-remove>Odstrani</button>
          </div>
        </div>
      `;
      }).join('');
    }

    // Notify any listeners (e.g. PDP cart-status indicator)
    document.dispatchEvent(new CustomEvent('pf:cart-updated', { detail: cart }));

    if (totalEl) totalEl.textContent = window.pfFormatMoney(cart.total_price);

    const savingsEl = drawer && drawer.querySelector('[data-pf-cart-savings]');
    const savingsAmt = drawer && drawer.querySelector('[data-pf-cart-savings-amt]');
    const totalDiscount = (cart.original_total_price || 0) - (cart.total_price || 0);
    if (savingsEl && savingsAmt) {
      if (totalDiscount > 0) {
        savingsAmt.textContent = '−' + window.pfFormatMoney(totalDiscount);
        savingsEl.removeAttribute('hidden');
      } else {
        savingsEl.setAttribute('hidden', '');
      }
    }

    const upsell = drawer && drawer.querySelector('[data-pf-cart-upsell]');
    if (upsell) {
      const upsellPid = parseInt(upsell.dataset.productId, 10);
      const upsellPrice = parseInt(upsell.dataset.price, 10) || 0;
      const inCart = cart.items.some(it => it.product_id === upsellPid);
      upsell.hidden = !(cart.item_count > 0 && !inCart && cart.total_price < FREE_SHIP_THRESHOLD);
      const lbl = upsell.querySelector('[data-pf-upsell-label]');
      if (lbl) {
        lbl.innerHTML = (cart.total_price + upsellPrice) >= FREE_SHIP_THRESHOLD
          ? 'Dodaj in odkleni <b>brezpla\u010dno po\u0161tnino</b> \ud83d\ude9a'
          : 'Odli\u010dna kombinacija s tvojim izborom';
      }
    }

    if (shipEl && shipBar) {
      const pct = Math.min(100, (cart.total_price / FREE_SHIP_THRESHOLD) * 100);
      shipBar.style.setProperty('--pf-ship-pct', pct + '%');
      if (cart.total_price >= FREE_SHIP_THRESHOLD) {
        shipEl.innerHTML = '🎉 <b>Brezplačna dostava</b> odklenjena!';
        shipEl.classList.add('is-unlocked');
        shipBar.classList.add('is-complete');
      } else {
        const left = FREE_SHIP_THRESHOLD - cart.total_price;
        shipEl.innerHTML = 'Še <b>' + window.pfFormatMoney(left) + '</b> do brezplačne dostave';
        shipEl.classList.remove('is-unlocked');
        shipBar.classList.remove('is-complete');
      }
    }
  }

  function fetchCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(r => r.json())
      .then(renderCart)
      .catch(() => {});
  }
  fetchCart();

// Line qty change
  document.addEventListener('click', function (e) {
    const q = e.target.closest('[data-pf-line-qty]');
    const rm = e.target.closest('[data-pf-line-remove]');
    if (!q && !rm) return;
    const line = (q || rm).closest('[data-pf-line]');
    if (!line) return;
    const key = line.dataset.pfLine;
    let quantity;
    if (rm) {
      quantity = 0;
    } else {
      const cur = parseInt(line.querySelector('.pf-cart-item__qty span').textContent, 10) || 1;
      quantity = q.dataset.pfLineQty === 'up' ? cur + 1 : Math.max(0, cur - 1);
    }
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(r => r.json())
      .then(() => fetchCart());  // always refetch fresh cart for accurate totals
  });

  // Cart upsell quick-add
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('[data-pf-upsell-add]');
    if (!btn) return;
    e.preventDefault();
    const box = btn.closest('[data-pf-cart-upsell]');
    const vid = box && parseInt(box.dataset.variantId, 10);
    if (!vid) return;
    btn.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: vid, quantity: 1 })
    })
      .then(r => r.json())
      .then(() => { showFlash('\u2713 Izdelek dodan'); fetchCart(); })
      .catch(() => {})
      .finally(() => { btn.disabled = false; });
  });

  // Add-to-cart form submit
  document.addEventListener('submit', function (e) {
    const form = e.target.closest('form[data-pf-atc-form]');
    if (!form) return;
    e.preventDefault();
    const fd = new FormData(form);
    fetch('/cart/add.js', { method: 'POST', body: fd, headers: { 'Accept': 'application/json' } })
      .then(r => r.json())
      .then(() => {
        showFlash('✓ Izdelek dodan');
        openDrawer();
        fetchCart();
      })
      .catch(() => {});
  });

  // Buy-now (skip cart → /checkout)
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('[data-pf-buy-now]');
    if (!btn) return;
    e.preventDefault();
    const form = btn.closest('form[data-pf-atc-form]');
    if (!form) return;
    const fd = new FormData(form);
    fetch('/cart/add.js', { method: 'POST', body: fd, headers: { 'Accept': 'application/json' } })
      .then(() => { window.location.href = '/checkout'; });
  });

  // ─────────────── Sticky ATC (PDP) ───────────────
  const sticky = document.querySelector('[data-pf-sticky-atc]');
  const atcBox = document.querySelector('[data-pf-atc-trigger]');
  if (sticky && atcBox && 'IntersectionObserver' in window) {
    const io = new IntersectionObserver(entries => {
      entries.forEach(ent => {
        if (ent.isIntersecting) sticky.classList.remove('is-visible');
        else sticky.classList.add('is-visible');
      });
    }, { threshold: 0 });
    io.observe(atcBox);

    const stickyBtn = sticky.querySelector('[data-pf-cart-open]');
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function (e) {
        e.preventDefault();
        const form = document.querySelector('form[data-pf-atc-form]');
        if (!form) { openDrawer(); fetchCart(); return; }

        const original = stickyBtn.innerHTML;
        stickyBtn.disabled = true;
        stickyBtn.innerHTML = 'Dodajam...';

        const fd = new FormData(form);
        fetch('/cart/add.js', { method: 'POST', body: fd, headers: { 'Accept': 'application/json' } })
          .then(r => r.json())
          .then(() => {
            showFlash('✓ Izdelek dodan');
            openDrawer();
            fetchCart();
          })
          .catch(() => { /* silent */ })
          .finally(() => {
            stickyBtn.innerHTML = original;
            stickyBtn.disabled = false;
          });
      });
    }
  }

  // ── Public cart API ──────────────────────────────────────────────────────
  // pf-collection-grid.liquid's quick-add dispatches 'pf:cart:added' and calls
  // window.PFCart.refresh(). Neither existed, so quick-add silently added the
  // item without ever opening the drawer. Debounced so the event + the direct
  // call collapse into a single /cart.js fetch.
  var _pfRefreshT = null;
  function pfRefreshSoon() {
    clearTimeout(_pfRefreshT);
    _pfRefreshT = setTimeout(fetchCart, 50);
  }
  window.PFCart = { open: openDrawer, close: closeDrawer, refresh: pfRefreshSoon };
  document.addEventListener('pf:cart:added', function () {
    openDrawer();
    pfRefreshSoon();
  });
})();

/* ============ PF Video sound toggle (How-to-Use, Experts) ============ */
function pfToggleSound(btn) {
  var wrap = btn.closest('[data-pf-video-wrap]');
  if (!wrap) return;

  var video = wrap.querySelector('video');
  if (!video) return;

  video.muted = !video.muted;

  if (!video.muted) {
    video.volume = 1;
    var playPromise = video.play();
    if (playPromise) {
      playPromise.catch(function () { /* silently ignore */ });
    }
  }

  var mutedIcon = btn.querySelector('.pf-howto__sound-muted');
  var onIcon = btn.querySelector('.pf-howto__sound-on');
  if (video.muted) {
    if (mutedIcon) mutedIcon.style.display = '';
    if (onIcon) onIcon.style.display = 'none';
    btn.setAttribute('aria-label', 'Vklopi zvok');
  } else {
    if (mutedIcon) mutedIcon.style.display = 'none';
    if (onIcon) onIcon.style.display = '';
    btn.setAttribute('aria-label', 'Izklopi zvok');
  }
}